// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ShortValue implements flatbuffers.IUnpackableObject<ShortValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ShortValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsShortValue(bb: flatbuffers.ByteBuffer, obj?: ShortValue): ShortValue {
    return (obj || new ShortValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsShortValue(bb: flatbuffers.ByteBuffer, obj?: ShortValue): ShortValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ShortValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startShortValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt16(0, value, 0);
  }

  static endShortValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createShortValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    ShortValue.startShortValue(builder);
    ShortValue.addValue(builder, value);
    return ShortValue.endShortValue(builder);
  }

  unpack(): ShortValueT {
    return new ShortValueT(this.value());
  }

  unpackTo(_o: ShortValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): ShortValueT {
    const t = new ShortValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class ShortValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ShortValue.createShortValue(builder, this.value);
  }

  clone(): ShortValueT {
    const obj = new ShortValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: ShortValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyShortValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
